<template>
  <div class="integral-mall">
    <!-- 顶部积分栏 -->
    <div class="top-section">
      <!-- <h2>积分商城</h2> -->
      <div class="integral-info">
        <p>我的积分</p>
        <div class="point-list">
          <div class="integral-number">12</div>
          <button class="record-btn">兑换记录</button>
        </div>
      </div>
    </div>

    <!-- 标签切换栏 -->
    <div class="tab-bar">
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'platform' }"
        @click="activeTab = 'platform'"
      >
        平台商品
      </button>
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'member' }"
        @click="activeTab = 'member'"
      >
        会员站独立积分
      </button>
    </div>

    <!-- 商品列表（根据标签切换显示，此处简化为同一列表） -->
    <div class="goods-list">
      <div class="goods-item" v-for="(item, index) in goodsList" :key="index">
        <img
          src="https://yckj-common.oss-cn-beijing.aliyuncs.com/1611124888.png"
          alt=""
          class="goods-img"
        />
        <h3 class="goods-title">{{ item.title }}</h3>
        <div class="goods-meta">
          <span>{{ item.integral }}积分</span>
          <span>剩余{{ item.remain }}张</span>
        </div>
        <button class="exchange-btn">立即兑换</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntegralMall",
  data() {
    return {
      activeTab: "platform", // 默认激活“平台商品”标签
      goodsList: [
        { title: "无门槛立减5元券", integral: 700, remain: 34 },
        { title: "无门槛立减5元券", integral: 700, remain: 34 },
        { title: "无门槛立减5元券", integral: 700, remain: 34 },
        { title: "无门槛立减5元券", integral: 700, remain: 34 },
      ],
    };
  },
};
</script>

<style scoped>
/* 顶部积分栏 */
.top-section {
  width: 100%;
  /* height: 160px; */
  background-color: #e67e22;
  color: #fff;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top-section h2 {
  font-size: 20px;
  margin: 0;
}

.integral-info {
  text-align: left;
  margin-top: 20px;
}

.integral-info p {
  font-size: 20px;
  margin-top: -20px;
}

.point-list {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.integral-number {
  font-size: 50px;
  margin: 4px 0;
}

.record-btn {
  margin-top: 10px;
  margin-left: 20px;
  /* 基础样式 - 空心带边框 */
  border: 2px solid #fff; /* 边框宽度、样式、颜色 */
  background-color: transparent; /* 透明背景，实现空心效果 */
  color: #fff; /* 文字颜色，与边框协调 */

  /* 尺寸与间距 */
  padding: 2px 4px; /* 内边距，控制按钮大小 */
  font-size: 12px; /* 文字大小 */

  /* 外观优化 */
  border-radius: 4px; /* 圆角，可选 */
  cursor: pointer; /* 鼠标悬停时显示手型 */
  transition: all 0.3s ease; /* 过渡动画，提升交互体验 */

  /* 去除默认按钮样式 */
  outline: none;
  box-shadow: none;
}
.record-btn:hover {
  border-color: #fff; /* 边框颜色加深 */
  color: #fff; /* 文字颜色同步变化 */
}

/* 点击状态 */
.record-btn:active {
  border-color: #000; /* 边框颜色更深 */
  color: #000;
}
/* 标签切换栏 */
.tab-bar {
  display: flex;
  border-bottom: 1px solid #ddd;
}

.tab-btn {
  padding: 12px 24px;
  border: none;
  background-color: #fff;
  cursor: pointer;
  font-size: 16px;
}

.tab-btn.active {
  color: #e67e22;
  border-bottom: 2px solid #e67e22;
}

/* 商品列表 */
.goods-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 16px;
}

.goods-item {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 8px;
  text-align: center;
}

.goods-img {
  width: 100%;
  height: auto;
  border-radius: 4px;
}

.goods-title {
  font-size: 16px;
  margin: 8px 0;
}

.goods-meta {
  display: flex;
  justify-content: space-between;
  margin: 8px 0;
  color: #db6337;
}
.goods-meta span:nth-child(2) {
  color: #9a9696;
}
.exchange-btn {
  background-color: #000;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
}
</style>
